const array = [
    {array:[{id: 1, name:"A to Z"}, {id: 2, name:"Z to A"}], name: "Order"},
    {array:[{id: 1, name:"Min Weight"}, {id: 2, name:"Max Weight"}], name: "Weight"},
    {array:[{id: 1, name:"All Dogs"}, {id: 2, name:"API Dogs"}, {id: 3, name:"Created Dogs"}], name: "Dogs"}
];

export default array